import { render, staticRenderFns } from "./vueTinymce.vue?vue&type=template&id=ff1ba3ca&"
import script from "./vueTinymce.vue?vue&type=script&lang=js&"
export * from "./vueTinymce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports